export default "__VITE_ASSET__AJH973VO__"